import React, { Children, useMemo, useState } from 'react'

import { InfiniteScroll } from 'components'

export type ListPropType = {
    limit?: number
}

/**
 * Компонент отображения списка по частям с автоподгрузкой
 * @param {object} params
 * @param params.children
 * @param {number} [params.limit]
 */
const List: React.FC<ListPropType> = ({ children, limit = 10 }) => {
    const [itemsLimit, setItemsLimit] = useState(limit)
    const [isHideLoader, setIsHideLoader] = useState(false)

    const counts = useMemo(() => Children.count(children), [children])

    const list = useMemo(() => {
        return Children.toArray(children).slice(0, itemsLimit)
    }, [children, itemsLimit])

    const handlerLoad = () => {
        const nextLimit = itemsLimit + limit

        setItemsLimit(nextLimit)

        if (nextLimit >= counts) {
            setIsHideLoader(true)
        }
    }

    return (
        <InfiniteScroll isHideLoader={isHideLoader} onLoad={handlerLoad}>
            {list}
        </InfiniteScroll>
    )
}

export default List
